/**
 * Different input key hints.
 * https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/enterkeyhint
 *
 * @private
 */
enum InputKeyHint {
	"Search" = "search",
	"Go" = "go",
	"Next" = "next",
	"Enter" = "enter",
	"Done" = "done",
	"Previous" = "previous",
	"Send" = "send",
}

export default InputKeyHint;
